module.exports = __webpack_public_path__ + "img/paulinavega.a8a23794.jpg";